import { render, staticRenderFns } from "./aPricingStrategyRuleTypeConditionFieldAmountSlider.vue?vue&type=template&id=20c5a34d&scoped=true"
import script from "./aPricingStrategyRuleTypeConditionFieldAmountSlider.vue?vue&type=script&lang=js"
export * from "./aPricingStrategyRuleTypeConditionFieldAmountSlider.vue?vue&type=script&lang=js"
import style0 from "./aPricingStrategyRuleTypeConditionFieldAmountSlider.vue?vue&type=style&index=0&id=20c5a34d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c5a34d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VChip,VSlider})
